import { gsap } from 'gsap';

class AboutScreen {
    el = null;

    constructor(el) {
        this.el = el;
        this.initEventListeners();
    }

    initEventListeners() {
        this.el.addEventListener('click', e => {
            if (e.target.classList.contains('jsClose')) {
                e.preventDefault();
                this.hide();
            }
        });
    }

    show() {
        const els = this.el.querySelectorAll('.jsTitle, .jsBlock');

        scrollWheelEnabled = true;

        gsap.timeline()
            .set(this.el, { opacity: 0 })
            .set(els, { y: 50, opacity: 0 })

            .add(() => this.el.classList.add('open'))

            .to(this.el, { duration: 0.5, opacity: 1, ease: 'power2.out' })
            .to(els, { duration: 1, y: 0, opacity: 1, ease: 'power2.out', stagger: 0.1 }, '-=0.2')

            .set([...els, this.el], { clearProps: 'all' })
        ;
    }

    hide() {
        const els = this.el.querySelectorAll('.jsTitle, .jsBlock');

        scrollWheelEnabled = false;

        gsap.timeline()
            .to(els, { duration: 0.5, y: 50, opacity: 0, ease: 'power2.in', stagger: 0.1 })
            .to(this.el, { duration: 0.5, opacity: 0, ease: 'power2.in' }, '-=0.5')

            .add(() => this.el.classList.remove('open'))
            .set(this.el, { clearProps: 'all' })
        ;
    }
}

export default AboutScreen;